import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../assets/css/general/termsAndConditions.css';

const TermsAndConditions = () => {
    const location = useLocation();
    const navigate = useNavigate();
   const handleGoBack = () => {
        if (location.state?.returnTo) {
            navigate(location.state.returnTo, { state: location.state.returnState });
        } else {
            navigate(-1);
        }
    };
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const sections = [
        {
            id: 'acceptance',
            icon: 'fas fa-handshake',
            title: '1. Acceptance of Terms',
            content: `By accessing and using the Northern Pakistan Gallery platform, you accept and agree to be bound by these Terms of Service. This platform serves three types of users: Customers, Vendors, and Administrators. If you do not agree to these terms, please do not use our services.`
        },
        {
            id: 'services',
            icon: 'fas fa-concierge-bell',
            title: '2. Platform Services',
            content: null,
            list: [
                { text: 'Hotel Bookings: Customers can browse and book hotels listed by verified Vendors.', bold: false },
                { text: 'Package Bookings: Customers can book travel packages curated by our Admin team.', bold: false },
                { text: 'Food & Event Blogs: Informational content about Northern Pakistan\'s cuisine and events.', bold: false },
                { text: 'Destination Guides: Curated destination information for travelers.', bold: false },
                { text: 'AI Travel Planner: AI-powered itinerary planning based on your budget and preferences.', bold: false },
                { text: 'Support Tickets: Customers can raise help & support tickets for assistance.', bold: false }
            ]
        },
        {
            id: 'customer',
            icon: 'fas fa-user',
            title: '3. Customer Responsibilities',
            content: null,
            list: [
                { text: 'Provide accurate personal and booking information at all times.', bold: false },
                { text: 'Ensure payment details are valid and you are authorized to use them.', bold: false },
                { text: 'Comply with hotel and vendor check-in/check-out policies.', bold: false },
                { text: 'Treat vendor properties and staff with respect.', bold: false },
                { text: 'Raise support tickets through the proper Help & Support channel for disputes.', bold: false }
            ]
        },
        {
            id: 'vendor',
            icon: 'fas fa-store',
            title: '4. Vendor Responsibilities',
            content: `Each Vendor on this platform is permitted to register and manage a single hotel property. Vendors agree to:`,
            list: [
                { text: 'Provide accurate hotel name, location, amenities, and room details.', bold: false },
                { text: 'Keep room availability and pricing information up to date.', bold: false },
                { text: 'Honor all confirmed bookings made through the platform.', bold: false },
                { text: 'Maintain the quality and standards described in their property listing.', bold: false },
                { text: 'Comply with all local hospitality laws and regulations.', bold: false },
                { text: 'The reservation amount collected at the time of booking will be retained by the platform as an admin commission, at a rate determined by the Admin.', bold: false }
            ]
        },
        {
            id: 'bookings',
            icon: 'fas fa-calendar-check',
            title: '5. Booking & Cancellation Policy',
            content: null,
            list: [
                { text: 'All bookings are subject to availability at the time of confirmation.', bold: false },
                { text: 'Package bookings follow cancellation terms set by the Admin.', bold: false },
                { text: 'Hotel booking cancellations are governed by the individual Vendor\'s policy.', bold: false },
                { text: 'Refunds, where applicable, will be processed within 7–14 business days.', bold: false },
                { text: 'No-shows may result in full charge of the booked amount.', bold: false }
            ]
        },
        {
            id: 'ai-planner',
            icon: 'fas fa-robot',
            title: '6. AI Travel Planner',
            content: `Our AI Planner generates travel itineraries based on your budget and preferences. Please note:`,
            list: [
                { text: 'AI-generated itineraries are suggestions only and not guaranteed bookings.', bold: false },
                { text: 'Actual prices may vary at the time of booking.', bold: false },
                { text: 'Northern Pakistan Gallery is not liable for any discrepancies between AI suggestions and actual availability.', bold: false },
                { text: 'Always confirm bookings through the official platform.', bold: false }
            ]
        },
        {
            id: 'payments',
            icon: 'fas fa-credit-card',
            title: '7. Payments',
            content: `All transactions on this platform are processed securely. By making a payment, you agree that:`,
            list: [
                { text: 'You are the authorized user of the payment method provided.', bold: false },
                { text: 'All prices are displayed in Pakistani Rupees (PKR) unless stated otherwise.', bold: false },
                { text: 'Payment must be completed to confirm any booking.', bold: false },
                { text: 'Northern Pakistan Gallery is not responsible for third-party payment processing fees.', bold: false }
            ]
        },
        {
            id: 'liability',
            icon: 'fas fa-shield-alt',
            title: '8. Limitation of Liability',
            content: `Northern Pakistan Gallery acts as an intermediary platform connecting Customers and Vendors. We are not liable for:`,
            list: [
                { text: 'Any damages arising from your use of this platform.', bold: false },
                { text: 'Inaccurate information provided by Vendors.', bold: false },
                { text: 'Disruptions to travel due to force majeure events.', bold: false },
                { text: 'Any indirect, incidental, or consequential damages.', bold: false }
            ]
        },
        {
            id: 'modifications',
            icon: 'fas fa-edit',
            title: '9. Modifications to Terms',
            content: `We reserve the right to modify these Terms of Service at any time. Changes will be posted on this page with a revised date. Continued use of the platform after changes constitutes your acceptance of the new terms. We encourage you to review these terms periodically.`
        },
        {
            id: 'contact',
            icon: 'fas fa-envelope',
            title: '10. Contact Us',
            content: `For any questions regarding these Terms of Service, please contact us:`,
            list: [
                { text: 'Email: legal@northern.pk', bold: true },
                { text: 'Phone: +92 300 123 4567', bold: true },
                { text: 'Office: Gilgit, Northern Pakistan', bold: true },
                { text: 'Hours: 9:00 AM – 6:00 PM (PKT), Monday – Saturday', bold: true }
            ]
        }
    ];

    const renderListItems = (items) => {
        return items.map((item, index) => {
            if (item.bold) {
                return <li key={index}><strong>{item.text}</strong></li>;
            }
            return <li key={index}>{item.text}</li>;
        });
    };

    return (
        <div className="tnc-page-wrapper">
            {/* Hero Section */}
            <div className="tnc-hero">
                <div className="tnc-hero-overlay"></div>
                <div className="tnc-hero-content">
                    <div className="tnc-hero-badge">
                        <i className="fas fa-file-contract me-2"></i>Legal
                    </div>
                    <h1 className="tnc-hero-title">Terms & Conditions</h1>
                    <p className="tnc-hero-subtitle">
                        Please read these terms carefully before using our platform
                    </p>
                </div>
                <div className="tnc-hero-svg">
                    <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                        <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#f8f9fa"/>
                    </svg>
                </div>
            </div>

            {/* Content */}
            <div className="tnc-content-wrapper">
                <div className="tnc-container">

                    {/* Intro Banner */}
                    <div className="tnc-intro-banner">
                        <i className="fas fa-info-circle tnc-intro-icon"></i>
                        <p>
                            These Terms & Conditions govern your use of the Northern Pakistan Gallery platform — 
                            a travel and hospitality marketplace connecting <strong>Customers</strong>, <strong>Vendors</strong>, 
                            and managed by our <strong>Admin team</strong>. By using our services, you agree to abide by these terms.
                        </p>
                    </div>

                    {/* Table of Contents */}
                    <div className="tnc-toc-card">
                        <h3 className="tnc-toc-title">
                            <i className="fas fa-list-ul me-2"></i>Table of Contents
                        </h3>
                        <div className="tnc-toc-grid">
                            {sections.map((section) => (
                                <a 
                                    key={section.id} 
                                    href={`#${section.id}`} 
                                    className="tnc-toc-item"
                                >
                                    <i className={section.icon}></i>
                                    <span>{section.title}</span>
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Sections */}
                    <div className="tnc-sections">
                        {sections.map((section) => (
                            <div key={section.id} id={section.id} className="tnc-section-card">
                                <div className="tnc-section-header">
                                    <div className="tnc-section-icon">
                                        <i className={section.icon}></i>
                                    </div>
                                    <h2 className="tnc-section-title">{section.title}</h2>
                                </div>
                                <div className="tnc-section-body">
                                    {section.content && <p className="tnc-section-text">{section.content}</p>}
                                    {section.list && (
                                        <ul className="tnc-section-list">
                                            {renderListItems(section.list)}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Back Button */}
                    <div className="tnc-footer-actions">
                       <button className="tnc-back-btn" onClick={handleGoBack}>
                       <i className="fas fa-arrow-left me-2"></i> Go Back
                     </button>
                        <button className="tnc-top-btn" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                            <i className="fas fa-arrow-up me-2"></i> Back to Top
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;